import { Layout, Menu, Dropdown, Avatar, Tag } from 'antd';
import {
  HomeOutlined,
  UserOutlined,
  FileOutlined,
  DollarOutlined,
  BarChartOutlined,
  MailOutlined,
  SettingOutlined,
  LogoutOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthStore, useAppStore } from '../store';
import { authAPI } from '../api/endpoints';
import './Sidebar.scss';

const Sidebar = () => {
  const navigate = useNavigate();
  const sidebarCollapsed = useAppStore((state) => state.sidebarCollapsed);
  const user = useAuthStore((state) => state.user);
  const logout = useAuthStore((state) => state.logout);

  const role       = user?.role;
  const isAdmin    = role === 'admin';
  const isOperator = role === 'operator';

  // Ítems visibles para admin y operador
  const operatorMenuItems = [
    {
      key: 'customers',
      icon: <UserOutlined />,
      label: 'Clientes',
      onClick: () => navigate('/customers'),
    },
    {
      key: 'invoices',
      icon: <FileOutlined />,
      label: 'Facturas',
      onClick: () => navigate('/invoices'),
    },
    {
      key: 'payments',
      icon: <DollarOutlined />,
      label: 'Pagos',
      onClick: () => navigate('/payments'),
    },
    {
      key: 'portfolio',
      icon: <BarChartOutlined />,
      label: 'Cartera',
      onClick: () => navigate('/portfolio'),
    },
  ];

  // Ítems exclusivos para admin
  const adminOnlyMenuItems = [
    {
      key: 'mailing',
      icon: <MailOutlined />,
      label: 'Correos',
      onClick: () => navigate('/mailing'),
    },
    {
      key: 'rules',
      icon: <SettingOutlined />,
      label: 'Reglas',
      onClick: () => navigate('/rules'),
    },
    {
      key: 'users',
      icon: <TeamOutlined />,
      label: 'Usuarios',
      onClick: () => navigate('/users'),
    },
  ];

  const menuItems = [
    {
      key: 'dashboard',
      icon: <HomeOutlined />,
      label: 'Dashboard',
      onClick: () => navigate('/'),
    },
    ...((isAdmin || isOperator) ? operatorMenuItems : []),
    ...(isAdmin ? adminOnlyMenuItems : []),
  ];

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Perfil',
      onClick: () => navigate('/profile'),
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Cerrar Sesión',
      onClick: () => {
        authAPI.logout().catch(() => {});
        logout();
        navigate('/login');
      },
    },
  ];

  return (
    <Layout.Sider
      trigger={null}
      collapsible
      collapsed={sidebarCollapsed}
      width={220}
      className="sidebar"
    >
      <div className="sidebar-header">
        {sidebarCollapsed ? (
          <img
            src="/nova-logo.png"
            alt="NOVA"
            className="sidebar-logo sidebar-logo--collapsed"
          />
        ) : (
          <img
            src="/nova-logo.png"
            alt="NOVA Imaging"
            className="sidebar-logo"
          />
        )}
      </div>

      <Menu
        theme="dark"
        mode="inline"
        items={menuItems}
        defaultSelectedKeys={['dashboard']}
      />

      <div className="sidebar-footer">
        <Dropdown menu={{ items: userMenuItems }} trigger={['click']}>
          <div className="user-info">
            <Avatar size="large" icon={<UserOutlined />} />
            {!sidebarCollapsed && (
              <div className="user-details">
                <span className="user-name">{user?.username}</span>
                <Tag
                  color={isAdmin ? 'blue' : isOperator ? 'purple' : 'default'}
                  style={{ fontSize: 10, marginTop: 2 }}
                >
                  {isAdmin ? 'Admin' : isOperator ? 'Operador' : 'Viewer'}
                </Tag>
              </div>
            )}
          </div>
        </Dropdown>
      </div>
    </Layout.Sider>
  );
};

export default Sidebar;
